import React from 'react'

export const IconDomains = (props = {}) => {
	const {size = 20, imgSize= 20, fill = "white"} = props
	return <>
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${size}px`}
				 viewBox={`0 0 ${imgSize} ${imgSize}`}
				 fill="none"
		>
			<path
				d="M15.8333 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V15.8333C2.5 16.2753 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H15.8333C16.2753 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2753 17.5 15.8333V4.16667C17.5 3.72464 17.3641 3.34041 17.0118 2.98816C16.6596 2.63591 16.2753 2.5 15.8333 2.5ZM16.25 15.8333C16.25 15.9438 16.2061 16.0498 16.128 16.128C16.0498 16.2061 15.9438 16.25 15.8333 16.25H4.16667C4.05616 16.25 3.95018 16.2061 3.87204 16.128C3.7939 16.0498 3.75 15.9438 3.75 15.8333V4.16667C3.75 4.05616 3.7939 3.95018 3.87204 3.87204C3.95018 3.7939 4.05616 3.75 4.16667 3.75H15.8333C15.9438 3.75 16.0498 3.7939 16.128 3.87204C16.2061 3.95018 16.25 4.05616 16.25 4.16667V15.8333ZM13.5417 5.83333H6.45833C6.29257 5.83333 6.1336 5.89918 6.01639 6.01639C5.89918 6.1336 5.83333 6.29257 5.83333 6.45833C5.83333 6.62409 5.89918 6.78307 6.01639 6.90027C6.1336 7.01748 6.29257 7.08333 6.45833 7.08333H13.5417C13.7074 7.08333 13.8664 7.01748 13.9836 6.90027C14.1008 6.78307 14.1667 6.62409 14.1667 6.45833C14.1667 6.29257 14.1008 6.1336 13.9836 6.01639C13.8664 5.89918 13.7074 5.83333 13.5417 5.83333Z"
				fill={fill} fillOpacity="0.6"
			/>
		</svg>
	</>
}
